module.exports = __webpack_public_path__ + "static/img/pad12.4ecb9685.png";